import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, {
  moment,
})

export default {
    install(Vue) {

        Vue.filter('roleName', function (value) {
            if (!value) return ''

            var roleString = "User";

            if (value >= 12) {
                roleString = "System Admin"
            } else if (value >= 10) {
                roleString = "Power Admin"
            } else if (value >= 8) {
                roleString = "Admin"
            } else if (value >= 6) {
                roleString = "Inward Goods User"
            } else if (value >= 5) {
                roleString = "Inward Goods Branch Login"
            } else if (value >= 2) {
                roleString = "Customer"
            }
            return roleString;
        })


        Vue.filter('currency', function (value) {
            if (!value) {
                value = 0;
            }
            return '$' + parseFloat(value).toFixed(2);
        });




        Vue.filter('fancyDate', function (value) {
            if (!value) {
                return '';
            } else {
                return "<em>" + moment(value).format('D') + "</em>" + moment(value).format('MMM');
            }
        });

        Vue.filter('jobid', function (value) {
            if (value) {
                return value.toString().substr(1);
            }
        });

        Vue.filter('branchFilter', function (value) {
            if (value === 0) {
                return "Wellington";
            } else if (value === 1) {
                return "Auckland";
            } else {
                return ""
            }
        });

        Vue.filter('prettyJSON', function(json){
            var obj = JSON.parse(json);
            if(obj.assignedUID) delete obj.assignedUID;
            if(obj.adminAttachments){
              /* for (const [key, value] of Object.entries(obj.adminAttachments)) {
                    console.log(`${key}: ${value}`);
                }
             */
            }




            json = JSON.stringify(obj);

            json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            /* json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
                var cls = 'number';
                if (/^"/.test(match)) {
                    if (/:$/.test(match)) {
                        cls = 'key';
                    } else {
                        cls = 'string';
                    }
                } else if (/true|false/.test(match)) {
                    cls = 'boolean';
                } else if (/null/.test(match)) {
                    cls = 'null';
                }
                return '<span class="' + cls + '">' + match + '</span>';
            });
            */
           return json;
        })



        Vue.filter('getCaps', function (value, uid, users, isSmall) {
            if (value) {
                var caps = value.replace(/[^A-Z]/g, '').substring(0, 2);
                var color = '#888';
                if (users) {

                    if (typeof users === 'object') {
                        var user = users.filter(x => x['.key'] == uid)[0];
                        // console.log('user', user);
                        if (user && user.colour) {
                            color = user.colour;
                        }
                    } else if (users) {
                        color = users;
                    }


                }

                //value = value.replace(/\"/g, '\\\"');

                if(isSmall){
                    return "<span style='background-color:" + color + "' title='" + value + "' class = 'spot spot-sm' > " + caps + " </span>";
                }else{
                    return "<span style='background-color:" + color + "' title='" + value + "' class = 'spot' > " + caps + " </span>";
                }
            }
        });


        Vue.filter('camelToWords', function (value) {
            if (value) {
                const result = value.replace(/([A-Z])/g, " $1");
                const finalResult = result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
                console.log(finalResult);

                //value = value.replace(/\"/g, '\\\"');
                return finalResult;
            }
        });



        Vue.filter('statusName', function (value) {
            if (value === 'Created' || value === 1) {
                return "Created by Customer";
            } else if (value === 3) {
                return "Created by Inwards Form";
            } else if (value === 6) {
                return "Inwards Goods Received";
            } else if (value === 10) {
                return "Cancelled";
            } else if (value === 15) {
                return "Completed";
            } else if (value === 50) {
                return "Note";
            } else {
                return "";
            }
        });

        Vue.filter('statusHex', function (value) {
            if (value === 'Created' || value === 1) { //secondary Created by customer 
                return "#8dc63f";
            } else if (value === "Pickup Booked") { //primary
                return "#4d8400";
            } else if (value === "Follow Up") { //Finalise
                return "#B20014"; //Red
            } else if (value === "Container/eCubes Deployed" || value === "Container_eCubes Deployed" || value === "Container Deployed") { 
                return "#3657b6";
            } else if (value === "Inwards Recorded") { //info Created by Inwards
                return "#36b9cc";
            } else if (value === "Teardown/Processing" || value === "Teardown_Processing") {
                return "#ffc107"; //warning
            } else if (value === "Shred/NZISM" || value === "Shred_NZISM") { //Created by Inwards
                return "#d32058"; //danger
            } else if (value === "Data Destruction Complete") { //Created by Inwards
                return "#840013"; //danger
            } else if (value === "Auck Completed") { //Discountinued
                return "#0022ee"; //darkinfo
            } else if (value === "Transfer") { //Transfer
                return "#0022ee"; //darkinfo
            } else if (value === "In Process") { //Transfer
                return "#0022ee"; //darkinfo
            } else if (value === "Dropping Off") { //Transfer
                return "#6d4e1b"; //brown
            } else if (value === "Finalise") { //Finalise
                return "#343a40"; //dark
            } else if (value === "Invoice") { //Invoice
                return "#212529"; //darker
            } else if (value === "Completed") { //Completed
                return "#000"; //black
            } else if (value === "Cancelled") { //Cancelled
                return "#e9ecef"; //light
            } else if (value === 50) { //Note
                return "#dc3545"; //danger
            } else {
                return "";
            }
        });



        Vue.filter('shortDate', function (value) {
            if (!value) {
                return '';
            } else if (moment(value).isSame(moment().startOf('day'), 'd')) {
                if (!moment(value).isAfter(moment().subtract(1, 'hours'))) {
                    return moment(value).format('h:mma');
                } else {
                    var duration = moment(value).fromNow();
                    return duration
                }
            } else if (moment(value).isSame(moment().subtract(1, 'days').startOf('day'), 'd')) {
                return 'Yday ' + moment(value).format('h:mma');
            } else if (moment(value) > moment().subtract(30, 'days')) {
                return moment(value).format("ddd, MMM D");
            } else {
                return moment(value).format("MMM D yy");
            }
        });

        Vue.filter('oldDate', function (value) {
            if (!value) {
                return '';
            } else if (moment(value).isSame(moment().startOf('day'), 'd')) {
                if (!moment(value).isAfter(moment().subtract(1, 'hours'))) {
                    return moment(value).format('h:mma');
                } else {
                    var duration = moment(value).fromNow();
                    return duration
                }
            } else if (moment(value).isSame(moment().subtract(1, 'days').startOf('day'), 'd')) {
                return 'Yday ' + moment(value).format('h:mma');
            } else {
                return moment(value).format("MMM D, yyyy");
            }
        });

        Vue.filter('chartDate', function (value) {
                return moment(value).format("ddd, MMM D YY");
        });


        Vue.filter('longDate', function (value) {
            if (!value) {
                return '';
            } else if (moment(value).isSame(moment().startOf('day'), 'd')) {
                if (!moment(value).isAfter(moment().subtract(1, 'hours'))) {
                    return 'Today ' + moment(value).format('h:mma');
                } else {
                    var duration = moment(value).fromNow();
                    return duration
                }
            } else if (moment(value).isSame(moment().subtract(1, 'days').startOf('day'), 'd')) {
                return 'Yesterday ' + moment(value).format('h:mma');
            } else if (moment(value) > moment().subtract(30, 'days')) {
                return moment(value).format("ddd, MMM Do h:mma");
            } else {
                return moment(value).format("MMM Do yy h:mma");
            }
        });

        Vue.filter('fullDate', function (value) {
            if (!value) {
                return '';
            } else if (moment(value).isSame(moment().startOf('day'), 'd')) {
                if (!moment(value).isAfter(moment().subtract(1, 'hours'))) {
                    return 'Today ' + moment(value).format('h:mma');
                } else {
                    var duration = moment(value).fromNow();
                    return duration
                }
            } else if (moment(value).isSame(moment().subtract(1, 'days').startOf('day'), 'd')) {
                return 'Yesterday ' + moment(value).format('h:mma');
            } else {
                return moment(value).format("ddd, MMM Do YYYY - h:mma");
            }
        });

        Vue.filter('fullDay', function (value) {
            if (!value) {
                return '';
            } else if (moment(value).isSame(moment().startOf('day'), 'd')) {
                if (!moment(value).isAfter(moment().subtract(1, 'hours'))) {
                    return 'Today ' + moment(value).format('MMM Do YYYY');
                }
            } else if (moment(value).isSame(moment().subtract(1, 'days').startOf('day'), 'd')) {
                return 'Yesterday ' + moment(value).format('MMM Do YYYY"');
            } else {
                return moment(value).format("ddd, MMM Do YYYY");
            }
        });

        Vue.filter('fullDateStatic', function (value) {
            if (!value) {
                return '';
            } else {
                return moment(value).format("ddd, MMM Do YYYY - h:mma");
            }
        });


    }
}